export enum SelectSegmentCategories {
    manufacturer = 'manufacturer',
    dealer = 'dealer',
    commercialPartner = 'commercialPartner',
}
